module.exports = __webpack_public_path__ + "img/yangshi@2x.9d79f1fa.png";